import React, { useState } from "react";
import "../../css/CostSummary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const CostSummary = ({ data, withNNW, withKR }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const calculateCostDetails = (participant) => {
    const { config } = data;
    let baseCost = config.elementsPrice;
    let adminCost = config.administrativeCosts;
    let tfgCost = config.isTouristEvent ? config.tfgContribution : 0;
    let nnwCost = (config.nnwRequired || data.nnwInsurance) ? config.nnwContribution : 0;
    let krCost = config.krContribution;

    const illnessMultiplier = participant.insurance?.isChronicIllness ? config.chronicIllnessMultiplier : 1;

    if (participant.insurance?.isChronicIllness) {
        if (config.isTouristEvent && config.isTripAbroad) {
            nnwCost *= illnessMultiplier;
        }
        if (config.isTouristEvent) {
            krCost *= illnessMultiplier;
        }
    }

    let totalCost = baseCost + adminCost + tfgCost 
        + (withNNW ? nnwCost : 0) 
        + (withKR ? krCost : 0);

    return {
        totalCost,
        baseCost,
        adminCost,
        nnwCost: withNNW ? nnwCost.toFixed(2) : null,
        krCost: withKR ? krCost.toFixed(2) : null,
        tfgCost: config.isTouristEvent ? tfgCost.toFixed(2) : null,
        illnessMultiplier: participant.insurance?.isChronicIllness ? `zwyżka ze względu na chorobę przewlekłą; mnożnik 1.8` : null
    };
};

  return (
    <div className="cost-summary-section">
      <h3>Podsumowanie kosztów</h3>
      {data.participants.map((participant, index) => {
        const costDetails = calculateCostDetails(participant);
        return (
          <div key={index} className="cost-summary-item" onClick={() => toggleExpand(index)}>
            <div className="cost-summary-item-header">
              <div className="participant-info">
                <span className="participant-name">{participant.preferredName}</span>
                <span className="participant-email">{participant.email}</span>
              </div>
              <div className="summary-price">
                <span className="value">{costDetails.totalCost.toFixed(2)} zł</span>
                <button className="expand-btn" >
                  <FontAwesomeIcon icon={expandedIndex === index ? faChevronUp : faChevronDown} />
                </button>
              </div>
            </div>

            {expandedIndex === index && (
              <div className="cost-details">
                <table className="cost-table">
                  <tbody>
                    <tr>
                      <td><strong>Suma kosztów wycieczki:</strong></td>
                      <td>{costDetails.baseCost.toFixed(2)} zł</td>
                    </tr>
                    <tr>
                      <td><strong>Koszty administracyjne:</strong></td>
                      <td>{costDetails.adminCost.toFixed(2)} zł</td>
                    </tr>
                    {costDetails.nnwCost && (
                      <tr>
                        <td><strong>Składka NNW:</strong></td>
                        <td>{costDetails.nnwCost} zł {costDetails.illnessMultiplier && data.config.isTouristEvent && data.config.isTripAbroad? `(${costDetails.illnessMultiplier})` : ""}</td>
                      </tr>
                    )}
                    {costDetails.krCost && (
                      <tr>
                        <td><strong>Składka KR:</strong></td>
                        <td>{costDetails.krCost} zł {costDetails.illnessMultiplier  && data.config.isTouristEvent ? `(${costDetails.illnessMultiplier})` : ""}</td>
                      </tr>
                    )}
                    {costDetails.tfgCost && (
                      <tr>
                        <td><strong>Składka TFG:</strong></td>
                        <td>{costDetails.tfgCost} zł</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}
      <div className="cost-summary-total">
        <table className="cost-table">
          <tbody>
            <tr>
              <td><strong>Łączna kwota do zapłaty:</strong></td>
              <td className="total-amount">
                {data.participants.reduce((acc, p) => acc + calculateCostDetails(p).totalCost, 0).toFixed(2)} zł
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {data.participants.reduce((acc, p) => acc + calculateCostDetails(p).totalCost, 0) > 0 && (
        <div className="payment-notice-inline">
          Płatność za wycieczkę będzie możliwa <strong>dopiero po otrzymaniu od nas e-maila</strong> z dalszymi instrukcjami.
          Jeśli Twoje zgłoszenie trafi na <span className="waitlist">listę rezerwową</span>, na tym etapie nic nie płacisz.
        </div>
      )}

    </div>
  );
};

export default CostSummary;
